import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import EWGUISandbox from './ewguiSandbox';


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <EWGUISandbox/>
  </React.StrictMode>
);



